import { inject, injectable } from "tsyringe";

// entities
import type { PatchStudentRequestDto } from "@/entities/user/models/dtos";

// pages
import type { SettingClassRowModel } from "@/pages/student-setting/ui/popup/setting-class/models/interface";
import { StringDateOrDateConverter } from "@/pages/student-setting/ui/popup/setting-class/services/service/StringDateOrDateConverter";
import { convertDayOfWeekStringToNumber } from "@/pages/student-setting/ui/popup/setting-class/services/utils";

export interface ClassDataFormatConverterStructure {
    convert: (classTimeData: SettingClassRowModel[]) => PatchStudentRequestDto;
}

@injectable()
export class ClassDataFormatConverter implements ClassDataFormatConverterStructure {
    constructor(
        @inject(StringDateOrDateConverter)
        private readonly stringDateOrConverter: StringDateOrDateConverter,
    ) {}

    public convert = (classTimeData: SettingClassRowModel[]) => {
        const requestDto: PatchStudentRequestDto = {
            timetable: {
                times: [],
            },
        };

        const filteredClassTimeData = classTimeData.filter((timeData) => timeData.isChecked);

        // 전달받은 string 타입을 Date 타입으로 변환합니다.
        filteredClassTimeData.forEach((timeData) => {
            const startTime = this.stringDateOrConverter.convertToDate(timeData.startTime);
            const endTime = this.stringDateOrConverter.convertToDate(timeData.endTime);
            const dayOfWeek = convertDayOfWeekStringToNumber(timeData.dayOfWeek);

            if (!startTime || !endTime) return;

            requestDto.timetable?.times.push({
                dayOfWeek: dayOfWeek,
                startAt: startTime,
                endAt: endTime,
            });
        });

        // 변경 작업을 진행합니다.
        return requestDto;
    };
}
